import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "@/components/container";
import { KeenIcon } from "@/components";
import {
  Toolbar,
  ToolbarActions,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { SystemAnnouncementsListings } from "./SystemAnnouncementsListings";
import { AnnouncementStatus } from "@/types/system-announcements.types";

const SystemAnnouncementsArchivedManagement = () => {
  const navigate = useNavigate();
  return (
    <Fragment>
      <Container>
        <Toolbar>
          <ToolbarHeading>
            <ToolbarPageTitle text="Archived system announcements" />
            <ToolbarDescription>
              View archived announcements.
            </ToolbarDescription>
          </ToolbarHeading>
          <ToolbarActions>
            <button
              type="button"
              className="btn btn-sm btn-light flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={() => navigate("/system-announcements")}
              aria-label="Back to system announcements"
            >
              <KeenIcon
                type="filled"
                icon="arrow-left"
                className="text-gray-500"
              />
              Back
            </button>
          </ToolbarActions>
        </Toolbar>
      </Container>

      <Container>
        <SystemAnnouncementsListings
          defaultStatusFilter={AnnouncementStatus.EXPIRED}
          hideStatusFilter
        />
      </Container>
    </Fragment>
  );
};

export { SystemAnnouncementsArchivedManagement };
